<div class="header">
  <h2>Dettaglio <strong>Macro Categoria</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li><a style="cursor: pointer;" [routerLink]="['/checklist']">Checklist</a></li>
      <li><a style="cursor: pointer;" [routerLink]="['/checklist/' + checklist.id_checklist]">Dettaglio Checklist</a></li>
      <li class="active">Dettaglio Macro Categoria</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-lg-4 col-md-12 col-sm-12">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-list"></i>Informazioni <strong>Macro Categoria</strong></h3>
      </div>
      <div class="panel-content">
        <h4>
          <i class="fa fa-check-circle-o"></i> <strong>Checklist:</strong>&nbsp;<a style="cursor: pointer;" [routerLink]="['/checklist/' + checklist.id_checklist]">{{ checklist?.name }}</a>
        </h4>
        <h4><i class="fa fa-key"></i> <strong>Codice:</strong> {{ checklistCategory?.code }}</h4>
        <h4><i class="fa fa-info-circle"></i> <strong>Titolo:</strong> {{ checklistCategory?.name }}</h4>
        <h4><i class="fa fa-book"></i> <strong>Descrizione:</strong> {{ checklistCategory?.description }}</h4>
        <h4><i class="fa fa-list"></i> <strong>Indice:</strong> {{ checklistCategory?.index }}</h4>
      </div>
      <div *ngIf="user.fk_id_role <= 1" class="panel-footer">
        <a class="btn btn-blue" [routerLink]="['/checklist-category/update/' + checklistCategory.id_checklist_category]"><i class="icon-pencil"></i> Modifica</a>
        <a class="btn btn-danger" (click)="openDeleteChecklistCategoryModal()"><i class="icon-trash"></i> Elimina</a>
      </div>
    </div>
  </div>
  <div class="col-lg-8 col-md-12 col-sm-12">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-list"></i> <strong>Requisiti</strong></h3>
      </div>
      <div class="panel-content">
        <table *ngIf="checklistSubCategories.length > 0" class="table table-hover">
          <thead>
          <tr>
            <th style="width: 10%;">Codice</th>
            <th style="width: 15%;">Titolo</th>
            <th style="width: 20%;">Livello di Servizio</th>
            <th style="width: 20%;">Standard di Riferimento</th>
            <th style="width: 20%;">Documenti di Verifica</th>
            <th class="text-right" style="width: 15%;">Azioni</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let checklistSubCategory of checklistSubCategories |
                  paginate: paginationConfig">
            <td>{{ checklistSubCategory.code }}</td>
            <td>{{ checklistSubCategory.name }}</td>
            <td>{{ checklistSubCategory.level }}</td>
            <td style="white-space: pre-line">{{ checklistSubCategory.standard }}</td>
            <td style="white-space: pre-line">{{ checklistSubCategory.documents }}</td>
            <td class="text-right">
              <a class="edit btn btn-sm btn-default" [routerLink]="['/checklist-subcategory/update/' + checklistSubCategory.id_checklist_subcategory]">
                <i class="icon-note"></i></a>
              <a class="delete btn btn-sm btn-danger" (click)="openDeleteChecklistSubCategoryModal(checklistSubCategory)">
                <i class="icons-office-52"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
        <div *ngIf="checklistSubCategories.length > 0">
          <pagination-controls (pageChange)="pageChanged($event)"
                               [autoHide]="paginationParams.autoHide"
                               [maxSize]="paginationParams.maxSize"
                               [responsive]="paginationParams.responsive"
                               [previousLabel]="paginationLabels.previousLabel"
                               [nextLabel]="paginationLabels.nextLabel"
                               [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                               [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                               [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
          ></pagination-controls>
        </div>
        <div *ngIf="checklistSubCategories.length === 0" style="text-align: center; height: 150px; padding-top: 60px;">
          Nessuna categoria associata.
        </div>
      </div>
      <div *ngIf="user.fk_id_role <= 1" class="panel-footer" style="text-align: center;">
        <a class="btn btn-success" [routerLink]="['/checklist-subcategory/create/' + checklistCategory.id_checklist_category]"><i class="icon-plus"></i> Aggiungi</a>
      </div>
    </div>
  </div>
</div>
